var React = require('react');

function Left (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / arrow / left"),React.createElement("g",{"key":1},React.createElement("polygon",{"transform":"translate(12.047000, 11.997500) rotate(90.000000) translate(-12.047000, -11.997500) ","points":"11.0465 0.0405 11.0465 20.1265 6.7535 15.8335 5.3395 17.2475 12.0465 23.9545 18.7545 17.2475 17.3395 15.8335 13.0465 20.1265 13.0465 0.0405"}))]);
}

Left.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Left;

Left.default = Left;
